import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const modules = {}

const requireNewModule = require.context('@/modules', true, /store\/index\.js$/) // extract js files inside modules folder

requireNewModule.keys().forEach(fileName => {
  const moduleName = fileName.replace(/(\.\/|\/store\/index\.js)/g, '')
  modules[moduleName] = requireNewModule(fileName).default
})


const store = new Vuex.Store({
  modules,
  plugins: [createPersistedState({
    key: 'inter-soc-sportive'
  })]
});

export default store
